import Vue from 'vue';
import Info from './quan.vue';

let create = (options) => {
  let component = Vue.extend(Info);
  let componentVue = {};
  return new Promise((resolve, reject) => {
    //实例化ConfirmConstructor组件
    componentVue = new component({
      el: document.createElement('div'),
      propsData:{
        // dataList:options.data,
        // activeIndex:options.activeIndex,
        item:options.item,

      }
    });
    for (let index in options) {
      componentVue[index] = options[index];
    }
    //返回vue实例
    componentVue.$on('complete', () => {
      resolve(componentVue)
    })
    // return componentVue;
  })
}

export default create;



// WEBPACK FOOTER //
// ./src/page/main_content/map/baseMap/info.js